const targetItems = document.querySelectorAll('.resillion-accordion-item');

targetItems.forEach((t) => {
    t.addEventListener('click', function() {
        targetItems.forEach((x) => {
            if(x.classList.contains('active') && x !== t) {
                x.classList.remove('active');
            }
        })
        t.classList.toggle('active');
    });
});